import React from 'react';

type IconSvgProps = {
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
};

export type IconComponent = React.ComponentType<{ className?: string; style?: React.CSSProperties }>;

const strokeProps = {
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
};

const IconSvg = ({ className, style, children }: IconSvgProps) => (
    <svg className={className} style={style} viewBox="0 0 24 24" {...strokeProps}>
        {children}
    </svg>
);

export const makeIcon = (children: React.ReactNode): IconComponent =>
    ({ className, style }) => (
        <IconSvg className={className} style={style}>
            {children}
        </IconSvg>
    );
